const isOffline = ({ status }) => status === 'disconnected';

const sortSegmentAscending = property => (a, b) => {
  const aIsOffline = isOffline(a);
  const bIsOffline = isOffline(b);

  if (aIsOffline) return -1; // sort a after b
  if (bIsOffline) return 1; // sort a before b

  return a[property] >= b[property] ? 1 : -1;
};

export default function sortSegments(segments, value, order) {
  const result = [...segments];

  switch (value) {
    case 'tti':
      result.sort(sortSegmentAscending('travelTimeIndex'));
      break;
    case 'speed':
      result.sort(sortSegmentAscending('liveSpeed'));
      break;
    default:
  }

  return order === 'asc' ? result : result.reverse();
}



// WEBPACK FOOTER //
// ./src/helpers/sortSegments.js